// extracted by mini-css-extract-plugin
module.exports = {"button":"connect-modal_button__20-_Z","header":"connect-modal_header__zambF"};